import React, { Component, Fragment } from 'react'

class VCCustomRow extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fullWidthStyle: null
    }
    this.containerNode = React.createRef()
  }

  handleResize = () => {
    const { clientWidth } = this.containerNode.current
    const space = (window.innerWidth - clientWidth) / 2
    const fullWidthStyle = {
      marginLeft: '-' + space + 'px',
      paddingLeft: space + 'px',
      marginRight: '-' + space + 'px',
      paddingRight: space + 'px'
    }
    this.setState({ fullWidthStyle })
  }

  componentDidMount() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    // clean up listeners
    window.removeEventListener('resize', this.handleResize)
  }
  render() {
    return (
      <Fragment>
        <div className={`row${this.props.className?' '+this.props.className:''}`}  style={this.state.fullWidthStyle}>
          {this.props.children}
        </div>
        <div className='row-size' ref={this.containerNode}>
          &nbsp;
        </div>
      </Fragment>
    )
  }
}

export default VCCustomRow



// WEBPACK FOOTER //
// ./src/custom/components/VCCustomRow.js